import styled from 'styled-components'

export const RecommendContainer = styled.div`
  .CarouselContainer__wrap {
    max-width: 1270px;
    margin: 0 auto;

    .slick-slider .slick-arrow::after {
      width: 24px;
      height: 24px;
    }

    .slick-slider .slick-arrow {
      width: 32px;
      height: 32px;
      margin-top: -50px;
    }

    .slick-slider .slick-next {
      right: 8px;
    }
    .slick-slider .slick-prev {
      left: 8px;
    }

  }

  .CarouselContainer {
    & > .container {
      text-align: ${({ centerTitle }) => centerTitle ? 'center' : 'left'};
      color: ${({ theme }) => theme.colors.gray1};
      font-size: 20px;
      font-weight: 500;
      line-height: 120%;
      margin-bottom: 16px;
      margin-top: 46px;
      max-width: 1250px;
      margin: auto;
    }
  }

  .WhiteBox--card-vehicle {
    margin: 0;
    padding: 0;
    figure {
      margin: 0 auto 8px;
    }
  }

  .btn-more-recapture {
    display: flex;
    width: 100%;
    max-width: 400px;
    margin: 80px auto 12px;
    font-weight: 700;
    text-transform: initial;
  }

  .slick-track {
    margin: 0 auto;
  }
`
